module.exports = __webpack_public_path__ + "static/media/E2.287fb707.jpg";